import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'lock-report',
    templateUrl: './lock-report.component.html',
    styleUrls: ['./lock-report.component.scss'],
})
export class LockReportComponent implements OnInit {
    @Input() lockedBy: string;
    @Input() lockedAt: Date;
    @Output() unlockReport = new EventEmitter<void>();
    constructor() {}

    ngOnInit(): void {}

    onUnlockReport() {
        this.unlockReport.emit();
    }
}
